import { post } from "@/api/http";
import profile from "./profile";
import main from "./main";

var serverLocation = main.getServerLocation();
const api2Rc = profile.apiUrl[serverLocation];
const fluidTokenUrl= api2Rc+"/service/generatetoken" //給azClient call Api用

export default {
  fluidTokenUrl,
  getMindMapSas: function () {
    return post("/mindmap/sas");
  },
  createMindMap: function (data) {
    return post("/mindmap/create-mindmap", data);
  },
  getMindMapsByTmid: function (data) {
    return post("/mindmap/get-mindmaps", data);
  },
  getMindMapByMid: function (data) {
    return post("/mindmap/get-mindmap-by-mid", data);
  },
  updateMindMap: function (data) {
    return post("/mindmap/update-mindmap", data);
  },
  deleteMindMap: function (data) {
    return post("/mindmap/delete-mindmap", data);
  },
  getFluidRelayConfig: function () {
      return post(api2Rc+"/area/serviceUrl");
  },
  getClipCode: function (data) {
    return post(api2Rc + "/Service/CreateClipCodes",data);
  },
  getOrigDataFromClipCode: function (data) {
    return post(api2Rc + "/Service/GetOrigDataFromClipCode",data);
  },

  //收集區的API
  createMindCollect: function (data) {
    return post("/mindcollect/create-mindcollect", data);
  },
  getMindCollectById: function (data) {
    return post("/mindcollect/get-mindcollect", data);
  },
  getMyMindCollects: function (data) {
    return post("/mindcollect/get-my-mindcollects", data);
  },
  updateMindCollect: function (data) {
    return post("/mindcollect/update-mindcollect", data);
  },
  deleteMindCollect: function (data) {
    return post("/mindcollect/delete-mindcollect", data);
  },
  deleteMindMaps: function (data) { //一次刪除多個mindmap 目前只有在刪除收集區時使用
    return post("/mindmap/delete-mindmaps", data);
  },
  saveMindClickHistory:function (data){
    return post("/mindmap/save-mind-history", data);
  },
  getMindClickHistory:function (data){
    return post("/mindmap/get-mind-history", data);
  },
  updateHistoryFavorite:function (data){
    return post("/mindmap/update-history-favorite", data);
  },
  getMindCollectNormalFoldersByTmid:function (data){
    return post("/mindmap/get-normal-folders", data);
  }
};
